import React, { useEffect, useState, useRef } from 'react';
import { getRouterUrl, Constants, refreshCookie, refreshSession, getSessionSupportUrl, getEnv, getCorrelationId, addQueryParamsIfMissing, deleteCookies } from '../utils/Utils';
import { configMap } from '../types';
import { useCIAMAuth } from '../hooks/useCIAMAuth';
//@ts-ignore
import MicroAppLoader from '@usb-ui-tools/micro-app-loader';

export const ExtendSession = (props: any) => {
  const { token, extendTime } = props;
  const ciamAuth = useCIAMAuth();
  const env = ciamAuth?.config?.env
  const config = configMap[getEnv(ciamAuth?.config)];
  const defaultProps = {
    test: {},
    configSettings: {
      displayFields: {
        ENROLLMENT_LINK: Constants.DISPLAY_FIELD.HIDE,
        ACCOUNT_TYPE_DROPDOWN: Constants.DISPLAY_FIELD.HIDE,
        LOGIN_HELP: Constants.DISPLAY_FIELD.SHOW,
      },
      regex: {
        USER_ID: '(.*?)',
        PASSWORD: '(.*?)',
      },
      urls: {
        JS_LOGGER_DOMAIN: `${config.JS_LOGGER_DOMAIN_URL}`, // https://ua2-onlinebanking.usbank.com  https://onlinebanking.usbank.com/
      },
      lang: {
        'en-us': {
          errorMessages: {
            USER_DISABLE_OLD:
              'It looks like your username has been disabled. Please contact <+1-866-288-2623> for help.',
          },
        },
      },
      transmitConfigs: {
        URL: `${config.TRANSMIT_CONFIG_URL}`,
        APP_ID: Constants.AUTH.APP_ID,
        policyIds: {
          POLICY: Constants.AUTH.POLICY,
          EXTEND_USER_SESSION: 'heartbeat',
          USER_LOGOUT: 'log_out',
        },
        policyParams: {
          appId: Constants.AUTH.APPLICATION_ID,
          tenantId: Constants.TENANT.ID,
          channelId: Constants.TENANT.CHANNEL,
          appVersion: Constants.AUTH.LOGIN_APP_VERSION,
          applicationId: Constants.AUTH.APPLICATION_ID,
          useCase: Constants.AUTH.USE_CASE,
          XProfileDataRequested: Constants.PROFILE.X_DATA_REQUESTED,
          correlationId: getCorrelationId(),
          routingKey: `${config.ROUTING_KEY}`,
          targetApp: `${ciamAuth.config.appId}`,
        },
      },
    },
    header: {
      'App-ID': Constants.AUTH.APPLICATION_ID,
      'Tenant-ID': Constants.TENANT.ID,
      'Channel-ID': Constants.TENANT.CHANNEL,
      'App-Version': Constants.AUTH.LOGIN_APP_VERSION,
      AK: `${config.HEADER_AK}`,
    },
  };
  
  const onAuthFailure = async() => {
    // Todo: clear browser cookies
    console.log(new Date(),'On Auth Failure. Failed to extend JWT');
    if(ciamAuth.ciamSession && ciamAuth.ciamSession.jwtToken) await deleteCookies(ciamAuth.ciamSession.jwtToken, `${getRouterUrl(ciamAuth.config)}`);
    if(ciamAuth.config?.logoutCallBack) {
      await ciamAuth.config.logoutCallBack();
    }
    // if(props.state == 'Active')
    window.location.href = addQueryParamsIfMissing(ciamAuth.config.appLogin, { targetApp: ciamAuth.config.appId, message: 'errorRefreshSession' });
  };
  const onAuthSuccess = async (e: any) => {
    if(props.state == 'Active') {
      console.log(new Date(),'On Auth success', e);
      if (e.Success && e.token) {
        await refreshSession(e.token, getSessionSupportUrl(ciamAuth.config));
        await refreshCookie(e.token, getRouterUrl(ciamAuth.config));
        await props.onSessionExtend(e.token);
        if(ciamAuth?.config?.refreshCallBack) {
          await ciamAuth.config.refreshCallBack(e.token);
        }
      }
    }
  };
  return <MicroAppLoader
    elementRef={useRef(null)}
    id="auth-extsession"
    manifestPath={config.MANIFEST_PATH}
    namespace="USBAuthExtSession"
    isDomainPrefixedToManifestPath={false}
    appProps={{
      configSettings: defaultProps.configSettings,
      currentToken: token,
      onTransmitAuthorizationFailure: onAuthFailure,
      onTransmitAuthorizationSuccess: onAuthSuccess,
      timerCount: extendTime, // ExtendSessionTimer
      loadIdleModule: false
    }}
  />
}